import { render, staticRenderFns } from "./VideoChatEnd.vue?vue&type=template&id=e8b5f6c8&scoped=true&"
import script from "./VideoChatEnd.vue?vue&type=script&lang=js&"
export * from "./VideoChatEnd.vue?vue&type=script&lang=js&"
import style0 from "./VideoChatEnd.vue?vue&type=style&index=0&id=e8b5f6c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b5f6c8",
  null
  
)

export default component.exports